import {
  GET_SHEET,
  ADD_NEW_SHEET,
  STORE_TO_IMAGE_LIST,
  STORE_SHEET_DATAS,
  RESET_SHEET_DATAS,
} from "./actionTypes"

export const getSheets = payload => ({
  type: GET_SHEET,
  payload,
})

export const addNewSheet = payload => ({
  type: ADD_NEW_SHEET,
  payload,
})

export const storeImageList = payload => ({
  type: STORE_TO_IMAGE_LIST,
  payload,
})

export const storeSheetDatas = payload => ({
  type: STORE_SHEET_DATAS,
  payload,
})

export const resetSheetDatas = () => ({
  type: RESET_SHEET_DATAS,
})
